import React from 'react'

function Info() {
  return (
    
<div className="panel-horizontal-content" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal">
  <p className="headline-lg">IDECABA es la Infraestructura de Datos Espaciales del Gobierno de la Ciudad Autónoma de
Buenos Aires, mediante la cual se disponibilizan, de manera estandarizada, los datos geográficos
generados y trabajados por y para la gestión.</p>
  </div>
</div>

  )
}

export default Info